import { useState } from 'react';

/**
 * Logo de la aplicación (especificación §3.1, §4.4): `alterrealitas_logo_v1.svg`
 * en `public/`. Si el archivo no carga, se muestra el nombre en texto.
 *
 * El `viewBox` del SVG se recortó al contenido (el original, 192×192, dejaba
 * dos tercios de margen vacío y el logo se veía diminuto). Pendiente del
 * diseño: el texto "ALTER REALITAS" pide la fuente Montserrat, que un SVG
 * usado como imagen no puede cargar, y se dibuja con una fuente de
 * reemplazo. La versión definitiva debe traer el texto convertido a curvas.
 */
export const LOGO_URL = '/alterrealitas_logo_v1.svg';

export function Logo({ className = 'h-9' }: { className?: string }) {
  const [falta, setFalta] = useState(false);
  if (falta) {
    return (
      <span className="whitespace-nowrap text-sm font-bold tracking-tight text-primary-700">
        Alter Realitas
      </span>
    );
  }
  return (
    <img src={LOGO_URL} alt="Alter Realitas" className={className} onError={() => setFalta(true)} />
  );
}
